import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {SubscriptionModel} from '../../../api/entity/subscription.model';
import {SubscriptionConverter} from '../../../api/entity/converter/subscription.converter';
import {SubscriptionDataService} from './subscriptionData.service';
import {
    AbstractDataServiceDtoSummaryAdapter
} from "../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter";
import {SubscriptionSummaryModel} from "../../../api/entity/subscriptionSummary.model";
import {SubscriptionSummaryConverter} from "../../../api/entity/converter/subscriptionSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class SubscriptionSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<SubscriptionSummaryModel, SubscriptionSummaryConverter, SubscriptionModel> {
    constructor(dataService: SubscriptionDataService, converter: SubscriptionSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): SubscriptionModel {
        return new SubscriptionModel();
    }
}
